/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { withLoadingAsync, showToast, showModal } from '../../services/common-service'
import styles from './styles.module.scss';
import { getBucket, getBucketVariable, deleteBucketVariable } from '../../services/bucket-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'
import SimpleEditor from '../../components/SimpleEditor';

const Bucket = () => {
    const [bucketsData, setBucketsData] = useState([]);
    const [isEditable, setIsEditable] = useState(false);
    const [editorBucketValue, setEditorBucketValue] = useState("")

    useEffect(() => {
        LoadBuckets();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // eslint-disable-next-line
    }, [bucketsData])

    const LoadBucketVariable = async (key) => {
        const bucketVariableResponse = await getBucketVariable(key)
        console.log(bucketVariableResponse)
        if (bucketVariableResponse){
            if (typeof bucketVariableResponse === "object") {
                setEditorBucketValue(JSON.stringify(bucketVariableResponse))
            }
            else{
                setEditorBucketValue(bucketVariableResponse)
            }
        }
    }

    const LoadBuckets = async () => {
        const bucketsResponse = await getBucket()
        console.log(bucketsResponse)
        if (bucketsResponse.items){
            setBucketsData(bucketsResponse.items)
        }
    }

    const handleDeleteBucket = async (key) => {
        const { response } = await showModal(
            'Atenção',
            'Tem certeza que deseja excluir a variável?'
        );
        if (response) {
            DeleteBucket(key)
        }
    }

    const DeleteBucket = async (key) => {
        withLoadingAsync(async () => {
            await deleteBucketVariable(key)
            await LoadBuckets()
        })
        showToast(BlipPortalToastTypes.SUCCESS, 'Variável excluída com sucesso');
    }

    const isJson = (str) =>  {
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
      }

    return (
        <>
            <div className="ph1 ph4-m ph5-ns mt2">
                <div className="flex justify-between mb2">
                    <div className="flex justify-start w-30">
                        <div className="items-center pt3">
                            <bds-typo variant="fs-24" >
                                Bucket
                            </bds-typo>
                        </div>
                    </div>
                    <div className="flex justify-end items-center w-40">
                        <div className="ml2">
                            <bds-button
                                variant="outline"
                                color="primary"
                                size="standard"
                                icon-left="refresh"
                                onClick={() => {
                                    withLoadingAsync(async () => {
                                        await LoadBuckets()
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex">
                    <div className='w-30'>
                        <div className={styles['variable-list']}>
                            <bds-paper elevation="static">
                                {bucketsData?.map((item, index) => (
                                    <div className="flex justify-between items-center">
                                            <div
                                                className='pointer ml3 w-100'
                                                onClick={() => {
                                                    LoadBucketVariable(item)
                                                    setIsEditable(false)
                                                }}
                                            >
                                                <bds-typo variant="fs-16" id={"texto " + index}>
                                                    {item}
                                                </bds-typo>
                                            </div>
                                        <div className="flex justify-end items-center">
                                            <div className='mr1'>
                                                <bds-button-icon
                                                    icon="edit"
                                                    id={"open " +index}
                                                    variant="secondary"
                                                    size="short"
                                                    onClick={() => {
                                                        LoadBucketVariable(item)
                                                        setIsEditable(true)
                                                    }}
                                                />
                                            </div>
                                            <div className=''>
                                                <bds-button-icon
                                                    icon="trash"
                                                    id={"delete " +index}
                                                    variant="secondary"
                                                    size="short"
                                                    onClick={() => {
                                                        handleDeleteBucket(item)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </bds-paper>
                        </div>
                    </div>
                    <div className='w-70'>
                        <bds-paper elevation="static">
                            <SimpleEditor
                                editable={isEditable}
                                value={isJson(editorBucketValue) ? JSON.stringify(JSON.parse(editorBucketValue), null, 2) : editorBucketValue}
                                onChange={(newValue) => setEditorBucketValue(newValue)}
                            />
                        </bds-paper>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Bucket
